(() => {
  const connected = new WeakSet();
  function connect(root) {
    if (connected.has(root)) return;
    const bar = root.querySelector('[data-fv-sticky-buy]');
    const info = root.querySelector('product-info');
    if (!bar || !info) return;
    connected.add(root);
    const button = bar.querySelector('[data-fv-sticky-add]');
    const main = () => info.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]');
    function refresh() {
      const source = main();
      if (!source) { bar.hidden = true; return; }
      const pending = info.dataset.fvSizePending === 'true';
      const busy = info.dataset.fvSelectionLoading === 'true' || source.classList.contains('loading');
      button.disabled = busy || (!pending && source.disabled);
      button.textContent = pending ? 'Choose your size' : source.textContent.trim();
      const price = info.querySelector('.price');
      if (price) bar.querySelector('[data-fv-sticky-price]').textContent = price.innerText.trim().replace(/\s+/g, ' ');
      const options = [...info.querySelectorAll('variant-selects[data-context="main"] input[type="radio"]:checked')].map(input => input.value);
      bar.querySelector('[data-fv-sticky-selection]').textContent = options.join(' / ') + (pending ? ' / Select a size' : '');
      bar.hidden = source.getBoundingClientRect().bottom > 0;
    }
    button.addEventListener('click', () => {
      if (info.dataset.fvSizePending === 'true') {
        const group = info.querySelector('[data-fv-size-option]');
        group?.scrollIntoView({block: 'center', behavior: 'smooth'});
        group?.querySelector('input:not(:disabled)')?.focus({preventScroll: true});
        const error = root.querySelector('[data-fv-size-error]');
        if (error) error.hidden = false;
      } else main()?.click();
    });
    let frame;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(refresh); };
    new MutationObserver(schedule).observe(info, {subtree: true, childList: true, attributes: true, characterData: true});
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule);
    info.addEventListener('change', schedule);
    refresh();
  }
  document.querySelectorAll('.fv-pdp-final').forEach(connect);
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('.fv-pdp-final').forEach(connect));
})();
